<template>
	<section id="create-user">
	<Notification corner="bottom-right" :closed="true" />
		<form @submit.prevent="save" novalidate="true">
			<container textButton="voltar" :pathName="path" :pathIcone="true">
				<div class="errors">
					<div v-if="submitted && $v.form.perfil.$error" class="invalid-feedback">
						<p v-if="!$v.form.perfil.required">O perfil é obrigatório</p>
					</div>

					<div v-if="submitted && $v.form.nome.$error" class="invalid-feedback">
						<p v-if="!$v.form.nome.required">O nome é obrigatório</p>
						<p v-if="!$v.form.nome.minLength">O nome deve ter pelo menos 5 caracteres</p>
						<p v-if="!$v.form.nome.alpha">O nome deve conter apenas caracteres do alfabeto</p>
					</div>

					<div v-if="(this.form.perfil.id === 2 || this.form.perfil.id === 3) && submitted && $v.form.curadoriaId.$error" class="invalid-feedback">
						<p v-if="(this.form.perfil.id === 2 || this.form.perfil.id === 3) && !$v.form.curadoriaId.required">A curadoria é obrigatória</p>
					</div>

					<div v-if="this.form.perfil.id === 3 && submitted && $v.form.sub.$error" class="invalid-feedback">
						<p v-if="this.form.perfil.id === 3 && !$v.form.sub.required">A Subcuradoria é obrigatória</p>
					</div>

					<div v-if="submitted && $v.form.email.$error" class="invalid-feedback">
						<p v-if="!$v.form.email.required">O email é obrigatório</p>
						<p v-if="!$v.form.email.email">O email, não está no formato</p>
					</div>
				</div>
				<load-content v-if="loadContent && listColecoes.length === 0" />
				<div class="form-container" v-if="!loadContent">
					<div class="grid user-info">
						<div v-if="this.$auth.user().perfil === 2"  :class="[submitted && $v.form.perfil.$error && 'is-invalid', 'item perfil']">
							<Multiselect v-model="form.perfil" :value="perfis[0]" :options="verificarPermissaoCadastroPorPerfil(perfis)" :close-on-select="true" :clear-on-select="true"
								:searchable="false" placeholder="Selecione o perfil" :showNoResults="true" selectedLabel="Selecionado"
								selectLabel="Clique para selecionar" deselectLabel="Clique para remover" label="nome" track-by="nome" :disabled="disableSelectLider">
								<template slot="noResult">
									Nenhum perfil encontrado
								</template>

								<template slot="noOptions">
									Nenhum perfil encontrado
								</template>
							</Multiselect>
						</div>
						<div v-else-if="this.$auth.user().perfil !== 6" :class="[submitted && $v.form.perfil.$error && 'is-invalid', 'item perfil']">
							<Multiselect :allowEmpty="false" v-model="form.perfil" :options="perfis" :close-on-select="true" :clear-on-select="true"
								:searchable="false" placeholder="Selecione o perfil" :showNoResults="true" selectedLabel="Selecionado"
								selectLabel="Clique para selecionar" deselectLabel="" label="nome" track-by="nome">
								<template slot="noResult">
									Nenhum perfil encontrado
								</template>

								<template slot="noOptions">
									Nenhum perfil encontrado
								</template>
							</Multiselect>
						</div>
						<div class="item status">
							<check-status :nome="statusNome" :checked="form.flagAtivo" @change="checkStatusChange"></check-status>
						</div>
						<div v-if="this.form.perfil.id === 2 || this.form.perfil.id === 3" :class="[(this.form.perfil.id === 2 || this.form.perfil.id === 3) && submitted && $v.form.curadoriaId.$error && 'is-invalid', 'item curadoria']">
							<Multiselect v-model="form.curadoriaId" @input="curadoriaAlteracao(form.curadoriaId)" :options="formatCuradoriaRaiz(curadorias.data)" :close-on-select="true" :clear-on-select="true"
								:searchable="false" placeholder="Vincular curadoria" :showNoResults="true" selectedLabel="Selecionado" :disabled="disableSelectLider"
								selectLabel="Clique para selecionar" deselectLabel="Clique para remover" label="nome" track-by="nome">
								<template slot="noResult">
									Nenhuma curadoria encontrada
								</template>

								<template slot="noOptions">
									Nenhuma curadoria encontrada
								</template>
							</Multiselect>
						</div>

						<div v-if="this.form.perfil.id === 3 && this.form.curadoriaId" :class="[(this.form.perfil.id === 3) && submitted && $v.form.sub.$error && 'is-invalid', 'item sub-curadoria']">
							<Multiselect v-model="form.sub" @input="subCuradoriaAlteracao(form.sub)" :options="formatCuradoriaFilha(curadorias.data, form.curadoriaId)" :close-on-select="true" :clear-on-select="true"
								:searchable="false" placeholder="Vincular Subcuradoria" :showNoResults="true" selectedLabel="Selecionado"
								selectLabel="Clique para selecionar" deselectLabel="Clique para remover" label="nome" track-by="nome">
								<template slot="noResult">
									Nenhuma Subcuradoria encontrada
								</template>

								<template slot="noOptions">
									Nenhuma Subcuradoria encontrada
								</template>
							</Multiselect>
						</div>

						<!-- Curadoria estava duplicada -->
						<!-- <div class="item curadoria">
							<multiselect v-model="form.curadoria" :options="curadorias.data" :close-on-select="true" :clear-on-select="true"
							:searchable="false" placeholder="Vincular curadoria" :showNoResults="true" selectedLabel="Selecionado"
							selectLabel="Clique para selecionar" deselectLabel="Clique para remover" label="nome" track-by="nome">
							</multiselect>
						</div> -->

						<div :class="[submitted && $v.form.nome.$error && 'is-invalid', 'item nome']">
							<input type="text" v-model.lazy="form.nome" id="nome" autocomplete="off" placeholder="Digite o seu nome" />
						</div>

						<div :class="[submitted && $v.form.email.$error && 'is-invalid', 'item email']">
							<input type="email" v-model.lazy="form.email" id="email" autocomplete="off" placeholder="Digite o seu e-mail" />
							<button v-if="$auth.user().id === $route.params.id" type="button" class="large btn-senha" @click='openModalPassword()'>
								<span>GERAR NOVA SENHA</span>
							</button>
						</div>

						<div class="item sobre">
							<textarea name="sobre" id="sobre" cols="30" rows="10" v-model.lazy="form.sobre" placeholder="Sobre"></textarea>
						</div>
					</div>
					<div class="btn-container">
						<div class="btn-frame">
							<button-submit class="large" type="submit" :disabled="loadingSubmit">
								<load-submit v-if="loadingSubmit"></load-submit>
								<span v-else>SALVAR</span>
							</button-submit>
						</div>
					</div>
				</div>
			</container>
		</form>
		<div class="colecoes" v-if="this.$route.params.id">
			<div class="table-wrapper" v-if="listColecoes.length > 0">
				<div class="table">
					<table>
						<thead>
							<tr>
								<th>Nome</th>
								<th>CriadoPor</th>
								<th>Data de modificação</th>
								<th></th>
							</tr>
						</thead>

						<tbody>
							<tr class="fields" v-for="(colecao, index) in listColecoes" :key="index">
								<td><span>{{ colecao.nome }}</span></td>
								<td><span>{{ colecao.autor }}</span></td>
								<td><span>{{ colecao.dtUpdate }}</span></td>
								<td class="vizualizar">
									<router-link :to="{ name: 'colecaoView', params: { id: colecao.id, botao: caminhoVolta}}">
										<button-submit type="button" style="margin-right: 5px;"><i class="far fa-eye"></i></button-submit >
									</router-link>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="paginacao" v-if="totalItens > 20">
					<Pagination :totalItens="totalItens" :currentPage="paginaAtual" @pagina="getPaginaAtual" />
				</div>
			</div>
			<div v-else >
				<p v-if="!loadContent">Não há coleções cadastradas para este usuário.</p>
			</div>
		</div>

		<!-- Modal para alterar senha -->
		<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
			<template v-slot:body>
				<div class="itens">
					<p class="texto">
						Alterar Senha do Usuário
					</p>
					<span v-if="msgError" :class="['errors', 'msg']">Senha Atual incorreta</span>
					<span v-if="msgConfirm" :class="['errors', 'msg']">Nova Senha e Confirmação são diferentes</span>
					<div :class="[msgError && 'is-invalid','item']">
						<input type="password" v-model.lazy="senhaAtual" id="senhaAtual" autocomplete="off" placeholder="Digite a senha atual" />
					</div>
					<div :class="[msgConfirm && 'is-invalid','item']">
						<input type="password" v-model.lazy="novaSenha" id="novaSenha" autocomplete="off" placeholder="Digite a nova senha" />
					</div>
					<div :class="[msgConfirm && 'is-invalid','item']">
						<input type="password" v-model.lazy="confirmaSenha" id="confirmaSenha" autocomplete="off" placeholder="Digite novamente a nova senha" />
					</div>
				</div>
			</template>

			<template v-slot:footer>
				<ButtonSubmit
					type="button"
					:onClick="() => updateSenha($auth.user().id)"
					class="xs confirm"
					style="margin-right: 10px;"
					>Confirmar </ButtonSubmit>
				<ButtonSubmit type="button" :onClick="closeModal" class="xs default">Cancelar</ButtonSubmit>
			</template>
		</Modal>
		<!-- Fim Modal para alterar senha-->

		<!-- Modal para Curadoria com Curador -->
		<Modal v-show="isModalCurador" @close="() => this.isModalCurador = !this.isModalCurador">
			<template v-slot:body>
				<div class="itens">
					<div>
						<p class="texto">
							Já possui Lider Curador ou Curador nessa Curadoria.
						</p>
					</div>
					<div class="msg">
						<p>Deseja alterar o Lider Curador ou Curador após salvar ?</p>
					</div>
				</div>
			</template>

			<template v-slot:footer>
				<ButtonSubmit
					type="button"
					:onClick="() => botaoConfirmaAlteracaoCurador()"
					class="xs confirm"
					style="margin-right: 10px;"
					>Confirmar </ButtonSubmit>
				<ButtonSubmit type="button" :onClick="closeModalCurador" class="xs default">Cancelar</ButtonSubmit>
			</template>
		</Modal>
		<!-- Fim Modal para Curadoria com Curador -->

	</section>
</template>

<script>
import { required, email, minLength, helpers } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import { usuarios } from '@/services/usuarios'
import { colecoes } from '@/services/colecoes'
import { curadoria } from '@/services/curadoria'
import CheckStatus from '@/components/shared/Status'
import Pagination from '@/components/shared/Pagination'
import Container from '@/components/shared/Container'
import ButtonSubmit from '@/components/shared/ButtonAction'
import LoadSubmit from '@/components/shared/LoadSubmit'
import Modal from '@/components/shared/Modal'
import Multiselect from 'vue-multiselect'
import LoadContent from '@/components/shared/LoadContent'

const alpha = helpers.regex('alpha', /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]*$/)

export default {
	name: 'createUsuario',
	components: { Container, ButtonSubmit, CheckStatus, LoadSubmit, Pagination, Modal, Multiselect, LoadContent },
	data () {
		return {
			form: {
				nome: '',
				curadoriaId: '',
				email: '',
				sobre: '',
				cpf: '',
				flagAtivo: true,
				perfil: '',
				sub: '',
				desvinculadoId: ''
			},
			path: '',
			listColecoes: [],
			submitted: false,
			loadingSubmit: false,
			totalItens: 0,
			paginaAtual: 1,
			caminhoVolta: '/usuarios/' + this.$route.params.id,
			curadorias: {
				data: []
			},
			subCuradorias: {
				data: []
			},
			isModalVisible: false,
			isModalCurador: false,
			senhaAtual: '',
			novaSenha: '',
			confirmaSenha: '',
			msgError: false,
			msgConfirm: false,
			loadContent: true,
			paramsUser: {
				id: '',
				nome: '',
				email: '',
				flagAtivo: '',
				perfil: '',
				curadoriaId: ''
			},
			curadoriaAlterada: '',
			subCuradoriaAlterada: '',
			permissaoAlterarCurador: false,
			disableSelectLider: false,
			statusNome: 'Status:'
		}
	},
	validations: {
		form: {
			nome: {
				required,
				alpha,
				minLength: minLength(5)
			},
			email: { required, email },
			perfil: { required },
			curadoriaId: { required },
			sub: { required }
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	},
	async created () {
		this.getPaginaAtual()
	},
	methods: {
		async getPaginaAtual () {
			this.curadorias = await curadoria.findByActive()

			if (this.$auth.user().perfil === 2) {
				this.form.perfil = this.perfis[2]
				this.form.curadoriaId = this.curadorias.data.find(c => c.id === this.$auth.user().curadoriaId)
				this.disableSelectLider = true
			}

			if (this.$route.params.id) {
				this.params = {
					...this.params,
					...this.$route.query
				}

				if (this.params && this.params.skip) {
					this.paginaAtual = parseInt(this.params.skip)
					this.params.skip = parseInt(this.params.skip) - 1
				} else {
					this.paginaAtual = 1
					this.params.skip = 0
				}

				this.params.usuario = this.$route.params.id
				const user = await usuarios.findById(this.$route.params.id)

				const listColecoes = await colecoes.find(this.params)

				this.listColecoes = listColecoes.data
				this.totalItens = listColecoes.data.length && listColecoes.data[0].total

				if (user.status === 200) {
					const { nome, curadoriaId, flagAtivo, perfil, email, sobre, cpf } = user.data

					if (perfil === 3) {
						const curardoriaAux = this.curadorias.data.find(c => c.id === curadoriaId)
						this.form = {
							nome,
							curadoriaId: this.curadorias.data.find(c => c.id === curardoriaAux.curadoriaId),
							flagAtivo,
							email,
							cpf,
							sobre,
							perfil: this.perfis.find(p => p.id === perfil),
							sub: curardoriaAux
						}
					} else {
						this.form = {
							nome,
							curadoriaId: this.curadorias.data.find(c => c.id === curadoriaId),
							flagAtivo,
							email,
							cpf,
							sobre,
							perfil: this.perfis.find(p => p.id === perfil)
						}
					}
					this.loadContent = false
				} else {
					// redirect to 404 page
					this.loadContent = false
					return this.$router.push({ name: 'curadoriaList' })
				}
			} else {
				this.loadContent = false
			}
		},

		async save () {
			this.submitted = true
			this.loadingSubmit = true
			this.$v.$touch()
			if (this.$v.form.nome.$invalid || this.$v.form.perfil.$invalid || this.$v.form.email.$invalid || ((this.form.perfil.id === 2 || this.form.perfil.id === 3) && this.$v.form.curadoriaId.$invalid) || (this.form.perfil.id === 3 && this.$v.form.sub.$invalid)) {
				this.loadingSubmit = false
				return
			}

			this.form = {
				...this.form,
				perfil: this.form.perfil.id,
				sobre: this.form.sobre ? this.form.sobre : '',
				cpf: this.form.cpf,
				flagAtivo: this.form.flagAtivo ? 1 : 0
			}

			// obtém os dados do perfil
			const perfil = this.perfis.find(el => this.form.perfil === el.id)
			if (perfil.nivelAssociacao === 'curadoria') {
				this.form.curadoriaId = this.form.curadoriaId.id
			} else if (perfil.nivelAssociacao === 'subcuradoria') {
				this.form.curadoriaId = this.form.sub.id
				this.form.sub = this.form.sub.id
			} else {
				this.form.curadoriaId = null
				this.form.sub = null
			}

			if (this.$route.params.id) {
				try {
					const user = await usuarios.update(this.$route.params.id, this.form)

					if (user.status === 200) {
						this.loadingSubmit = false
						setTimeout(() => {
							this.$router.push({ name: 'usuariosList', params: { message: 'Usuário Atualizado com sucesso !' } })
						}, 700)
					}
				} catch (error) {
					this.form.perfil = this.perfis.find(p => p.id === this.form.perfil)
					window.notificationEM.open('', error.response.data.msg, 'error')
					this.loadingSubmit = false
				}
			} else {
				try {
					await usuarios.create(this.form)
					this.loadingSubmit = false
					setTimeout(() => {
						this.$router.push({ name: 'usuariosList', params: { message: 'Usuário Cadastrado com sucesso !' } })
					}, 700)
					// }
				} catch (error) {
					this.form.perfil = this.perfis.find(p => p.id === this.form.perfil)
					window.notificationEM.open('', error.response.data.msg, 'error')
					this.loadingSubmit = false
					// return
				}
			}
		},
		checkStatusChange () {
			this.form.flagAtivo = !this.form.flagAtivo
			return this.form.flagAtivo
		},
		openModalPassword () {
			this.isModalVisible = true
		},
		async updateSenha (userId) {
			this.msgConfirm = false
			this.msgError = false

			if (this.novaSenha === this.confirmaSenha && this.novaSenha !== 0) {
				const data = {
					id: this.$auth.user().id,
					senhaAtual: this.senhaAtual,
					novaSenha: this.novaSenha
				}

				const user = await usuarios.updatePassword(data)

				if (user.status === 200) {
					this.closeModal()
				} else {
					this.msgError = true
				}
			} else {
				this.msgConfirm = true
			}
		},
		closeModal () {
			this.senhaAtual = ''
			this.novaSenha = ''
			this.confirmaSenha = ''
			this.isModalVisible = false
			this.msgConfirm = false
			this.msgError = false
		},
		closeModalCurador () {
			this.isModalCurador = false
		},
		formatCuradoriaRaiz (curadoriaRaiz) {
			const array = []
			curadoriaRaiz.find(c => {
				if (c.curadoriaId === null) {
					array.push(c)
				}
			})
			return array
		},
		formatCuradoriaFilha (curadoriaLista, curadoriaPai) {
			const array = []
			curadoriaLista.find(c => {
				if (c.curadoriaId === curadoriaPai.id) {
					array.push(c)
				}
			})
			return array
		},
		async curadoriaAlteracao (curadoria) {
			if (this.form.perfil.id === 2) {
				this.paramsUser.curadoriaId = curadoria.id
				await usuarios.find(this.paramsUser)
					.then(res => {
						if (res.data.length) {
							this.paramsUser.id = res.data[0].id
						}
					})
					.catch(err => {
						console.log(err)
					})
				if (this.paramsUser.id) {
					this.isModalCurador = true
				}
			}
		},
		async subCuradoriaAlteracao (subcuradoria) {
			if (this.form.perfil.id === 3) {
				this.paramsUser = {
					curadoriaId: subcuradoria.id
				}
				await usuarios.find(this.paramsUser)
					.then(res => {
						this.paramsUser = res.data[0]
					})
					.catch(err => {
						console.log(err)
					})

				if (this.paramsUser.id) {
					this.isModalCurador = true
					console.log('Já possui lider curador nessa curadoria')
				} else {
					console.log('Não possui lider curador nessa curadoria')
				}
			}
		},
		botaoConfirmaAlteracaoCurador () {
			this.form.desvinculadoId = this.paramsUser.id
			this.closeModalCurador()
		},
		verificarPermissaoCadastroPorPerfil (perfil) {
			if (this.$auth.user().perfil === 2) {
				const filtro = []
				filtro.push(perfil.find(p => p.id === 3))
				return filtro
			} else {
				return perfil
			}
		}
	},
	computed: {
		...mapState({ perfis: state => state.perfis.list })
	}
}
</script>

<style lang="scss" scoped>
#create-user {
	.form-container {
		display: grid;
		grid-template-columns: auto;
		grid-gap: 30px;
		margin-top: 26px;

		.grid {
			display: grid;
			grid-gap: 10px 16px;
			grid-template-columns: auto 250px;

			.btn-senha {
				border: none;
				outline: none;
				background-color: $success-color;
				color: #fff;
				font-weight: $font-weight-default-bolder;
				border-radius: 5px;
				padding: 20px 0;
				cursor: pointer;
				font-size: .9em;
				padding: 10px;
				margin-left: 10px;

				&:disabled {
					background-color: rgba($success-color, 0.7);
					cursor: default;
				}

				// Button Size
				&.large {
					width: 260px;
				}

				&.small {
					width: 200px;
				}

				&.xs {
					width: 90px;
					padding: 12px 0;
				}

				// Button Styles
				&.danger {
					background: $danger-color;
					color: #fff;
				}
				&.blue {
					background: $success-color;
				}

				&.default {
					background: $default-color;
					color: $main-color;
				}
			}

			.item {
				background-color: #f3f7fc;
				border-radius: 5px;
				color: #4f5c6b;
				min-height: 50px;
				display: flex;
				align-items: center;
				padding: 0 11px;

				label {
					font-weight: $font-weight-default-bolder;
				}

				textarea {
					width: 100%;
					min-height: 120px;
					margin: 20px 0 5px;
					margin-left: 5px;
				}

				input {
					width: 100%;
					border: none;
					outline: none;
					background: transparent;
					font-family: $font-family;
					color: $font-color;
					font-size: $font-size-input;
					margin-left: 5px;

					&::placeholder {
						font-weight: $font-weight-default-bolder;
						font-family: $font-family;
						color: $font-color;
						font-size: 1em;
					}

					&::-webkit-input-placeholder {
						font-weight: $font-weight-default-bolder;
						font-family: $font-family;
						color: $font-color;
						font-size: 1em;
					}

				}

				&.sobre {
					flex-direction: column;
					align-items: flex-start;
				}
			}

			.perfil {
				grid-area: perfil;
			}

			.status {
				grid-area: status;
			}

			.curadoria {
				grid-area: curadoria;
			}

			.sub-curadoria {
				grid-area: sub-curadoria;
			}

			.nome {
				grid-area: nome;
			}

			.email {
				grid-area: email;
			}

			.sobre {
				grid-area: sobre;
			}

			&.user-info {
				grid-template-areas:
					"perfil status"
					"nome nome"
					"curadoria curadoria"
					"sub-curadoria sub-curadoria"
					"email email"
					"sobre sobre";
			}
		}

		.btn-container {
			display: flex;
			align-items: flex-end;
			justify-content: center;

			.btn-frame {
				border-radius: 100px;
			}

			label {
				color: $main-color;
				font-size: .9em;
				margin-top: 30px;
				font-weight: $font-weight-default-bolder;
				cursor: pointer;
			}
		}
	}
	.colecoes {
		color: #000;
		margin-top: 40px;
		background-color: #fff;
		border-radius: 10px;
		padding: 24px 20px 34px 26px;
		position: relative;
		.vizualizar {
			a {
				padding: 0;
			}
			button {
				background: #00243E  0% 0% no-repeat padding-box;
				height: 30px;
				display: flex;
				color: #fff;
				color: #fff;
				height: 30px;
				border-radius: 5px;
				opacity: 1;
				padding: 0 10px 0 10px;
			}
		}
	}
}
</style>

<style lang="scss">
	.multiselect__option--selected:hover, .multiselect__option--selected.multiselect__option--highlight {
		background-color: inherit;
		color: inherit;
	}
</style>
